import http, { handleHttpError, handleHttpResponse } from 'services/http'
import { HTTPResponse, IPaginationResponse } from 'services/http/http.types'
import {
  ICreateProtectionTemplateDto,
  ICreateProtectionTemplateResponse,
  ICriteria,
  ICriteriaResponse,
  IDeleteProtectionTemplateResponse,
  IProtectionTemplate,
} from './protection.types'

export interface IGetProtectionTemplatesParams {
  nextPage?: string
  limit?: number
}

const getProtectionTemplates = async (
  params?: IGetProtectionTemplatesParams
): Promise<HTTPResponse<IPaginationResponse<IProtectionTemplate>>> => {
  return http.get('/nsi/v1/rating-templates', { params }).then(handleHttpResponse).catch(handleHttpError)
}

const createRatingTempalte = async (
  dto: ICreateProtectionTemplateDto
): Promise<HTTPResponse<ICreateProtectionTemplateResponse>> => {
  return http.post('/nsi/v1/rating-templates', dto).then(handleHttpResponse).catch(handleHttpError)
}

const deleteTemplate = async (
  templateId: IProtectionTemplate['id']
): Promise<HTTPResponse<IDeleteProtectionTemplateResponse>> => {
  return http.delete(`/nsi/v1/rating-templates/${templateId}`).then(handleHttpResponse).catch(handleHttpError)
}

const getTemplateCriteaFromTemplate = async (
  templateId: IProtectionTemplate['id']
): Promise<HTTPResponse<ICriteriaResponse>> => {
  return http.get(`/nsi/v1/rating-templates/${templateId}/criteria`).then(handleHttpResponse).catch(handleHttpError)
}

const createCriteriaFromTemplate = async (
  templateId: IProtectionTemplate['id'],
  dto: Omit<ICriteria, 'id'>
): Promise<HTTPResponse<ICriteriaResponse>> => {
  return http
    .post(`/nsi/v1/rating-templates/${templateId}/criteria`, dto)
    .then(handleHttpResponse)
    .catch(handleHttpError)
}

const updateCriteriaFromTemplate = async (
  templateId: IProtectionTemplate['id'],
  dto: Omit<ICriteria, 'id'>
): Promise<HTTPResponse<ICriteriaResponse>> => {
  return http.put(`/nsi/v1/criteria/${templateId}`, dto).then(handleHttpResponse).catch(handleHttpError)
}

const deleteCriteriaFromTemplate = async (criteriaId: ICriteria['id']): Promise<HTTPResponse<ICriteriaResponse>> => {
  return http.delete(`/nsi/v1/criteria/${criteriaId}`).then(handleHttpResponse).catch(handleHttpError)
}

const protectionTemplateApi = {
  getProtectionTemplates,
  createRatingTempalte,
  deleteTemplate,
  getTemplateCriteaFromTemplate,
  createCriteriaFromTemplate,
  updateCriteriaFromTemplate,
  deleteCriteriaFromTemplate,
}
export default protectionTemplateApi
